import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { getEnvio, saveEnvioArticulo } from "../../../project/services/EnvioArticuloService";
import { getCacheData } from "../../services/CacheService";
import EnvioArticuloDialog from "./EnvioArticuloDialog";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialEnvioArticulo = {
  codigoEnvio: "",
  fechaRegistracion: format(new Date(), "dd/MM/yyyy"),
  observaciones: "",
  motivoAnulacion: "",
};

const nameItemsText = "Envío de artículos";
//
// ###########################################################################
//
const EnvioArticulo = () => {
  const navigate = useNavigate();
  const params = useParams();
  const idEnvioArticulo = params.idEnvio;
  const action = params.action;
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [envioArticuloData, setEnvioArticuloData] = useState(initialEnvioArticulo);
  const [envioArticuloItems, setEnvioArticuloItems] = useState([]);
  const [envioArticuloEstadoRows, setEnvioArticuloEstadoRows] = useState([]);
  const [envioArticuloItem, setEnvioArticuloItem] = useState({});
  const [openEnvioArticuloDialog, setOpenEnvioArticuloDialog] = useState(false);
  const [actionCrud, setActionCrud] = useState("");
  const [areas, setAreas] = useState([]);
  const [actionTitle, setActionTitle] = useState("");
  const [valueACAreaDestino, setValueACAreaDestino] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACAreaDestino, setInputValueACAreaDestino] = useState("");

  const tableColumns = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "descripcion_articulo",
      headerName: "Descripción",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver artículo">
            <IconButton
              size="small"
              aria-label="view"
              onClick={() => handleClickActionCrud(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>

          {(action === "new" || action === "update") && (
            <>
              <Tooltip title="editar artículo">
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => handleClickActionCrud(params.row, "update")}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="eliminar artículo">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickActionCrud(params.row, "delete")}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableColumnsEstado = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        switch (_val) {
          case 'pendiente-recibir':
            _val = "PENDIENTE DE RECIBIR";
            break;
          case 'recibido':
            _val = "RECIBIDO";
            break;
          case 'anulado':
            _val = "ANULADO";
            break;
          default:
            _val = "ERROR";
        }
        return _val;
      },
    },
    {
      field: "ultimo_estado",
      headerName: "Estado actual?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ultimo_estado ? "SÍ" : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Operador",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "motivo",
      headerName: "Motivo",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.motivo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id_articulo || row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {

    if (action === "view") {
      setActionTitle("Ver");
    } else if (action === "update") {
      setActionTitle("Editar");
    } else if (action === "new") {
      setActionTitle("Nuevo");
    } else if (action === "delete") {
      setActionTitle("Anular");
    }

    loadAreas();

    if (action !== "new") {
      load();
    }
  }, []);
  //
  // ##########################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getEnvio(idEnvioArticulo);
    setIsDoingSomething(false);

    if (response.ok) {

      const _envioArticuloData = response.data.data;

      setEnvioArticuloData({
        ...envioArticuloData,
        codigoEnvio: _envioArticuloData.codigo,
        fechaRegistracion: _envioArticuloData.fecha_creacion,
        observaciones: _envioArticuloData.observaciones,
      });

      setValueACAreaDestino({
        id: _envioArticuloData.id_area_destino,
        label: _envioArticuloData.descripcion_area_destino,
      });
      setInputValueACAreaDestino(_envioArticuloData.descripcion_area_destino);

      setEnvioArticuloItems(response.data.data.envio_articulo_list);

      const _envio_estado_list = _envioArticuloData.envio_estado_list;

      if (action === "view") {
        setEnvioArticuloEstadoRows(_envio_estado_list);
      }
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.id !== localStorage.getItem("id_area_ventas"));
      let _areas = [];
      _response.forEach((item) => {
        _areas.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setAreas(_areas);
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/envio-articulo-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setEnvioArticuloData({
      ...envioArticuloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleCloseEnvioArticuloDialog = () => {
    setOpenEnvioArticuloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleClickActionCrud = async (parEnvioArticuloItem, parAction) => {
    setActionCrud(parAction);
    setEnvioArticuloItem(parEnvioArticuloItem);
    setOpenEnvioArticuloDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleOnSave = (parItemCrud, parAction) => {
    let _envioArticuloItems = [...envioArticuloItems];

    if (parAction !== "delete") {
      let _existe = false;

      _envioArticuloItems.forEach((item) => {
        if (parAction === "new" ? true : item.id !== parItemCrud.id) {
          if (parItemCrud.codigo_articulo === item.codigo_articulo) {
            _existe = true;
          }
        }
      });

      if (_existe) {
        setMessage({
          messageText: "El artículo ya ha sido registrado",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (parAction === "new") {
        _envioArticuloItems.push(parItemCrud);
      } else {
        _envioArticuloItems.splice(
          _envioArticuloItems.findIndex(
            (articulo) => articulo.codigo_articulo === parItemCrud.codigo_articulo
          ),
          1
        );
        _envioArticuloItems.push(parItemCrud);
      }
      setEnvioArticuloItems(_envioArticuloItems);
    } else {
      _envioArticuloItems.splice(
        _envioArticuloItems.findIndex(
          (articulo) => articulo.codigo_articulo === parItemCrud.codigo_articulo
        ),
        1
      );
      setEnvioArticuloItems(_envioArticuloItems);
    }
    setOpenEnvioArticuloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleSave = () => {

    if (action === "new" || action === "update") {

      if (!valueACAreaDestino || valueACAreaDestino.id === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Area de destino",
        });
        setShowMessage(true);
        return;
      }

      if (envioArticuloItems.length === 0) {
        setMessage({
          messageText: "Debes agregar al menos un artículo para enviar",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    } else {

      if (!envioArticuloData.motivoAnulacion) {
        setMessage({
          messageText: "Debes ingresar el motivo de la anulación",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }

    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {

    let _envioArticuloObject = {};
    if (action === "new" || action === "update") {
      _envioArticuloObject = {
        id_area_destino: valueACAreaDestino.id,
        observaciones: envioArticuloData.observaciones,
        envio_articulo_list: envioArticuloItems.map((item) => ({
          id_articulo: item.id_articulo,
          cantidad: parseInt(item.cantidad),
        })),
      };
      if (action === "update") {
        _envioArticuloObject.id = idEnvioArticulo;
      }
    } else {
      _envioArticuloObject = {
        id: idEnvioArticulo,
        motivo_anulacion: envioArticuloData.motivoAnulacion,
      };
    }

    setIsDoingSomething(true);
    const response = await saveEnvioArticulo(action, _envioArticuloObject);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        handleCancelar();
      }, 1000);
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  return (
    <>
      <Paper elevation={1} sx={{
        borderStyle: "solid",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        p: 1,
        m: 1,
        maxWidth: "100%"
      }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ m: 1, mb: 3 }}
            >
              <Typography variant="h5" display="block" gutterBottom >
                {actionTitle} {nameItemsText} {envioArticuloData.codigoEnvio}
              </Typography>
            </Box>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                size="small"
                value={valueACAreaDestino}
                onChange={(event, newValue) => {
                  setValueACAreaDestino(newValue);
                }}
                inputValue={inputValueACAreaDestino}
                onInputChange={(event, newInputValue) => {
                  setInputValueACAreaDestino(newInputValue);
                }}
                id="AreaDestino"
                options={areas}
                renderInput={(params) => <TextField {...params} label="Area de Destino" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(option) => option.label || ""}
                disabled={action === "view" || action === "delete"}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={2}>
              <TextField
                id="fechaRegistracion"
                label="Fecha de Registración"
                variant="outlined"
                size="small"
                name="fechaRegistracion"
                value={envioArticuloData.fechaRegistracion}
                disabled={true}
              />
            </Grid>
          </Grid>

          {(action === "new" || action === "update") && (
            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", ml: 1, mb: 2 }}
              >
                <Tooltip title="agregar artículo">
                  <Button
                    className="btn-add"
                    variant="contained"
                    onClick={() => handleClickActionCrud({}, "new")}
                    startIcon={<Add />}
                  >
                    Agregar Artículo
                  </Button>
                </Tooltip>
              </Box>
            </Grid>
          )}

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Artículos {action === "view" ? "enviados" : "a enviar"}
                </Typography>
                <DataGrid
                  rows={envioArticuloItems}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={envioArticuloData.observaciones ? envioArticuloData.observaciones.toUpperCase() : ""}
                onChange={handleChange}
                disabled={action === "view" || action === "delete"}
                multiline
                rows={3}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: "80px",
                    minWidth: "400px",
                  },
                }}
              />
            </Grid>

            {(action === "delete") && (
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  sx={{ width: "100%", mb: 1, mt: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de Anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={envioArticuloData.motivoAnulacion ? envioArticuloData.motivoAnulacion.toUpperCase() : ""}
                  onChange={handleChange}
                  disabled={action === "view"}
                />
              </Grid>
            )}
          </Grid>

          {envioArticuloEstadoRows.length > 0 && (
            <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
              <Grid item xs={12}>
                <Box>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Estados del Envío de Artículos
                  </Typography>
                  <DataGrid
                    rows={envioArticuloEstadoRows}
                    columns={tableColumnsEstado}
                    {...tableOptions}
                  />
                </Box>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
            >
              {action !== "view" && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={action !== "delete" ? "primary" : "error"}
                  startIcon={
                    action !== "delete" ? (
                      <SaveIcon />
                    ) : (
                      <RemoveCircleOutlineIcon />
                    )
                  }
                >
                  {action !== "delete"
                    ? "Guardar"
                    : "Anular"}
                </Button>
              )}

              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelar}
              >
                {action === "view"
                  ? "Cerrar"
                  : "Cancelar"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper >

      {openEnvioArticuloDialog && (
        <EnvioArticuloDialog
          actionCrud={actionCrud}
          envioArticuloItem={envioArticuloItem}
          onSave={handleOnSave}
          onClose={handleCloseEnvioArticuloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {/* >>>> Messages */}

      {
        showMessage && (
          <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
        )
      }

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default EnvioArticulo;